import { Component, inject } from '@angular/core';
import { ApiHomeRow, ApiTopicItem } from '@tytapp/api';
import { FollowButton, HomeCard, HomeCardComponentType } from '@tytapp/app/pages/home-page/home-cards.service';
import { ArticlesService } from '@tytapp/articles';
import { Link } from '@tytapp/common';
import { UserService } from '@tytapp/user';

@Component({
    selector: 'tyt-home-topic-card',
    templateUrl: './topic-card.component.html',
    styleUrls: ['./topic-card.component.scss']
})
export class TopicCardComponent implements HomeCardComponentType {
    private userService = inject(UserService);
    private articlesService = inject(ArticlesService);

    card: HomeCard & ApiHomeRow;
    expectedCount = 4;

    get title() {
        if (this.card.type === 'must_see')
            return `Today's Must See Shows`;

        return this.card.title ?? this.card?.topic?.name ?? 'More Content';
    }

    get icon() {
        if (this.card.topic) {
            return {
                type: 'image',
                url: '/assets/icons-2019/topics.svg'
            } as const;
        } else {
            return {
                type: 'material',
                text: 'star'
            } as const;
        }
    }

    get followButton(): FollowButton {
        if (this.card?.topic) {
            return { type: 'CMS::Topic', id: this.card.topic.id };
        }
    }

    get classes() {
        let set = [];
        if (this.card?.topic)
            set.push('has-topic');
        else
            set.push('no-topic');

        if (this.card.type === 'must_see')
            set.push('must-see');

        return set;
    }

    get more(): Link {
        if (!this.card)
            return undefined;

        if (this.card.type === 'must_see') {
            return {
                url: this.userService.entitled ? '/feed/episodes' : '/feed/clips'
            };
        } else if (this.card.topic) {
            return {
                url: `/topics/${this.card.topic.slug}`
            };
        }

        return undefined;
    }

    playlistForTopicItem(topicItem: ApiTopicItem) {
        if (topicItem.type === 'vod') {
            return topicItem.vod_type === 'episode' ? 'episodes' : 'clips';
        } else if (topicItem.type === 'article') {
            return 'articles';
        }

        return 'clips';
    }

    commentTopicForTopicItem(topicItem: ApiTopicItem) {
        if (topicItem.type === 'vod')
            return `vod_${topicItem.vod_id}`;
        if (topicItem.type === 'article')
            return `article_${topicItem.article_id}`;

        return null;
    }

    badgeTypeForTopicItem(topicItem: ApiTopicItem) {
        if (topicItem.type === 'vod') {
            return topicItem.vod_type;
        } else if (topicItem.type === 'article') {
            return 'article';
        }

        return 'clip';
    }

    isValidTitle(title: string) {
        if (!title)
            return false;
        return title.trim() !== '';
    }

    linkForTopicItem(topicItem: ApiTopicItem) {
        if (topicItem.type === 'vod') {
            return `/watch/${topicItem.brand_id}/${topicItem.production_id}/${topicItem.vod_type}s/${topicItem.vod_id}`;
        } else if (topicItem.type === 'article') {
            return this.articlesService.getArticleUrlFromTopicItemSync(topicItem);
        }

        // uh oh
        return `javascript:;`;
    }

}